import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=a2e00d10&scoped=true"
import script from "./staff.vue?vue&type=script&lang=js"
export * from "./staff.vue?vue&type=script&lang=js"
import style0 from "./staff.vue?vue&type=style&index=0&id=a2e00d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e00d10",
  null
  
)

export default component.exports